import React from 'react';
import { useParams } from 'react-router-dom';
import GameEngine from '../GameEngine/GameEngine';
import { getGameEngineConfig } from '../../config/games';
import SEOHead from '../SEOHead/SEOHead';
import './GamePage.scss';

/**
 * Dynamic Game Page Component
 * Eliminates the need for individual boilerplate game components
 * Fetches game configuration based on URL parameter and renders GameEngine
 */
const GamePage = () => {
  const { gameId } = useParams();
  
  // Get the fully assembled config object from the Single Source of Truth
  const gameConfig = getGameEngineConfig(gameId);

  if (!gameConfig) {
    return (
      <>
        <SEOHead
          title="Game Not Found"
          description="The requested game was not found. Try one of our other daily challenge games!"
          canonicalUrl={`https://guessnexus.com/solve/${gameId}`}
        />
        <div className="game-page-error">
          <h2>Game Not Found</h2>
          <p>Error: Game configuration for "{gameId}" not found.</p>
          <p>Available games: slay-the-spire, bible-books, subnautica-creatures, aoe2-units, pokemon</p>
        </div>
      </>
    );
  }

  // Create structured data for the game page
  const gameStructuredData = {
    "@context": "https://schema.org",
    "@type": "VideoGame",
    "name": `${gameConfig.title} Daily Challenge`,
    "description": `${gameConfig.description}. Play the daily ${gameConfig.title} guessing game on GuessNexus.`,
    "url": `https://guessnexus.com/solve/${gameId}`,
    "applicationCategory": "Game",
    "operatingSystem": "Web",
    "playMode": "SinglePlayer",
    "genre": gameConfig.category || "Puzzle Game",
    "publisher": {
      "@type": "Organization",
      "name": "GuessNexus",
      "url": "https://guessnexus.com"
    }
  };

  return (
    <>
      <SEOHead
        title={`${gameConfig.title} Daily Challenge`}
        description={`Challenge yourself with today's ${gameConfig.title} daily puzzle! ${gameConfig.description}. Can you solve it? Play now and compete with thousands of players!`}
        canonicalUrl={`https://guessnexus.com/solve/${gameId}`}
        structuredData={gameStructuredData}
      />
      <GameEngine config={gameConfig} />
    </>
  );
};

export default GamePage;